(() => {
  document.documentElement.classList.add('pgw-motion-enabled');

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const revealSelectors = [
    '.pg-home-origin__picture',
    '.pg-home-origin__content',
    '.pg-home-origin__chapters',
    '.pg-principles__item',
    '.pg-home-ledger__index',
    '.pg-home-ledger__stage',
    '.pg-home-ledger__records',
    '.pg-home-close__story',
    '.pg-home-close__signup',
    '.trade-portfolio__header',
    '.trade-portfolio__item',
    '.trade-portfolio__footer'
  ].join(',');

  const imageSelectors = [
    '.pg-home-origin__picture',
    '.story-origin__large',
    '.story-founder__media',
    '.journal-featured__media',
    '.contact-pathways__media'
  ].join(',');

  const addStagger = (root) => {
    root.querySelectorAll('.trade-portfolio__item').forEach((item, index) => {
      item.style.setProperty('--pgw-delay', `${Math.min(index * 65, 455)}ms`);
    });

    root.querySelectorAll('.pg-principles__item').forEach((item, index) => {
      item.style.setProperty('--pgw-delay', `${index * 80}ms`);
    });
  };

  const markTargets = (root) => {
    root.querySelectorAll(revealSelectors).forEach((target) => {
      target.setAttribute('data-pgw-reveal', '');
    });

    root.querySelectorAll(imageSelectors).forEach((target) => {
      target.setAttribute('data-pgw-image-reveal', '');
    });

    addStagger(root);
  };

  const revealAll = (root) => {
    root.querySelectorAll('[data-pgw-reveal], [data-pgw-image-reveal]').forEach((target) => {
      target.classList.add('is-visible');
    });
  };

  const observe = (root = document) => {
    markTargets(root);

    const targets = root.querySelectorAll('[data-pgw-reveal], [data-pgw-image-reveal]');

    if (motionQuery.matches || !('IntersectionObserver' in window)) {
      revealAll(root);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -7% 0px',
        threshold: 0.1
      });
    }

    targets.forEach((target) => {
      if (!target.classList.contains('is-visible')) observer.observe(target);
    });
  };

  const init = () => observe(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));

  motionQuery.addEventListener?.('change', (event) => {
    if (event.matches) revealAll(document);
  });
})();